import React from "react";
import "./Footer.css";

import { FaInstagram, FaFacebook, FaReddit } from "react-icons/fa";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-main">
        © 2035 by Blog it. Powered and secured by{" "}
        <span>
          <a href="https://ayush15421.netlify.app/">SAS</a>
        </span>
      </div>
      <div className="iconss">
        <FaInstagram size={25} />
        <FaFacebook size={25} />
        <FaReddit size={25} />
      </div>
    </div>
  );
};

export default Footer;
